/* eslint-disable no-console */
import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import update from 'immutability-helper'

import Icon from 'Pods/Shared/Icon/Icon'
import InputField from 'Pods/Shared/InputField'
import GetFileTypeRenderers from 'Utils/GetFileTypeRenderers'

import FileRow from 'Pods/Profile/Products/ArchiveSection/FileRow'

class ArchiveFileInfoRow extends React.Component {
  constructor(props) {
    super(props)

    const fileTypeId = props.fileInfo && props.fileInfo.fileTypeId

    this.state = {
      renderersList: GetFileTypeRenderers(props.fileTypes, fileTypeId),
      fileTypeId,
      version: props.fileInfo.version ? props.fileInfo.version : '',
      rendererId: props.fileInfo.rendererId,
      rendererVersion: props.fileInfo.rendererVersion ? props.fileInfo.rendererVersion : '',
      nativeFormat: props.fileInfo.nativeFormat,
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.onAttributeUpdate = this.onAttributeUpdate.bind(this)
    this.canBeNative = this.canBeNative.bind(this)
    this.onNativeTrigger = this.onNativeTrigger.bind(this)
  }

  handleInputChange(e) {
    const newState = update(this.state, { [e.target.name]: { $set: e.target.value } })
    this.setState(newState)

    this.onAttributeUpdate(e.target.name, e.target.value)
  }

  onAttributeUpdate(attribute, value) {
    const newState = update(this.state, { [attribute]: { $set: value } })

    if (attribute === 'fileTypeId') {
      newState.renderersList = this.props.fileTypes.find(fileType => fileType.id === value).renderers
    }

    this.setState(newState)

    this.props.updateFileAttribute(this.props.fileId, this.props.fileInfoId, attribute, value)
  }

  canBeNative() {
    return this.props.fileTypes.find((fileType) => (fileType.id === this.state.fileTypeId && fileType.canBeNative))
  }

  onNativeTrigger() {
    this.setState(prevState => ({ nativeFormat: !prevState.nativeFormat }))

    this.props.onFileNativeTrigger(this.props.fileId, this.props.fileInfoId, this.state.fileTypeId, !this.state.nativeFormat)
  }

  render() {
    return (
      <FileRow id={this.props.fileInfoId} key={this.props.fileInfoId} notSpaced>
        {this.canBeNative() && (
          <div className="file-row__col file-row__col--native is-native-visible">
            <input
              id={`file-row-${this.props.fileInfoId}`}
              className="checkbox"
              type="checkbox"
              checked={this.state.nativeFormat}
              onChange={this.onNativeTrigger}
              disabled={this.props.nativeCheckDisabled}
            />
            <label htmlFor={`file-row-${this.props.fileInfoId}`}>Native</label>
          </div>
        )}

        <div className="file-row__col file-row__filename">
          <span><i>Please choose file format</i></span>
        </div>

        <div className={`file-row__col ${this.state.renderersList.length > 0 ? 'file-row__col--break' : ''}`}>
          <div className="file-row__info-section">
            {this.props.fileTypesForSelect.length > 0 && (
              <Select
                className="Select-outline file-row__select"
                options={this.props.fileTypesForSelect}
                placeholder="Software"
                searchable
                clearable={false}
                value={this.state.fileTypeId}
                onChange={(data) => data && data.value && this.onAttributeUpdate('fileTypeId', data.value)}
              />
            )}

            <InputField
              placeholder="Version"
              id={`${this.props.fileInfoId}-version`}
              name="version"
              value={this.state.version}
              formClassName="form-group-grey"
              inputClassName="form-control-grey"
              onChange={(e) => this.handleInputChange(e)}
            />
          </div>

          {this.state.renderersList.length > 0 && (
            <div className="file-row__info-section">
              <Select
                className="Select-outline file-row__select"
                options={this.state.renderersList.map(({ id, title }) => ({ value: id, label: title }))}
                placeholder="Renderer"
                searchable
                clearable={false}
                value={this.state.rendererId}
                onChange={(data) => this.onAttributeUpdate('rendererId', data.value)}
              />

              <InputField
                placeholder="Version"
                id={`${this.props.fileInfoId}-renderer-version`}
                name="rendererVersion"
                value={this.state.rendererVersion}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                onChange={(e) => this.onAttributeUpdate(e.target.name, e.target.value)}
              />
            </div>
          )}
        </div>

        <div
          className="file-row__col file-row__col--close"
          onClick={() => this.props.removeFileInfo(this.props.fileId, this.props.fileInfoId)}
        >
          <Icon type={['fal', 'times']} notSpaced />
        </div>
      </FileRow>
    )
  }
}

ArchiveFileInfoRow.propTypes = {
  fileId: PropTypes.string.isRequired,
  fileInfoId: PropTypes.string.isRequired,
  fileInfo: PropTypes.shape({
    fileTypeId: PropTypes.number,
    fileTypeTitle: PropTypes.string,
    nativeFormat: PropTypes.bool,
    rendererTitle: PropTypes.string,
    rendererId: PropTypes.number,
    rendererVersion: PropTypes.string,
    version: PropTypes.string,
  }),
  fileTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      canBeNative: PropTypes.bool,
      renderers: PropTypes.array.isRequired,
    }).isRequired
  ).isRequired,
  fileTypesForSelect: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  updateFileAttribute: PropTypes.func.isRequired,
  removeFileInfo: PropTypes.func.isRequired,
  onFileNativeTrigger: PropTypes.func.isRequired,
  nativeCheckDisabled: PropTypes.bool,
}

ArchiveFileInfoRow.defaultProps = {
  fileInfo: {
    fileTypeId: 0,
    fileTypeTitle: '',
    nativeFormat: false,
    rendererTitle: '',
    rendererId: 0,
    rendererVersion: '',
    version: '',
  },
}

export default ArchiveFileInfoRow
